import React from 'react';
import styled from 'styled-components';

import { Chip, Icon, Tooltip } from '@column/column-ui-kit';

const NotSendableWrapper = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NotSendableChip = () => {
  return <Chip type="warning" size="small" variant="subtle" icon={<Icon.CircleCross />} />;
};

export const AuthorizationCell = ({ isAuthorized }: { isAuthorized?: boolean }) => {
  if (isAuthorized) {
    return null;
  }

  return (
    <NotSendableWrapper>
      <Tooltip content="You do not have permission to send this transfer." placement="right">
        <NotSendableChip />
      </Tooltip>
    </NotSendableWrapper>
  );
};
